import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { CapitalizeFirstPipe } from './capitalize-first.pipe';

@Pipe({
  name: 'username',
})
export class UsernamePipe implements PipeTransform {
  userDeletedText: string;

  constructor(
    private transloco: TranslocoService,
    private _capitalizePipe: CapitalizeFirstPipe,
  ) {
    this.transloco
      .selectTranslate('USERS.USER_DELETED')
      .subscribe((userDeletedText) => {
        this.userDeletedText = userDeletedText;
      });
  }

  transform(user: any, firstCamelLastCapitalize = false): string {
    if (user?.archivedAt) {
      return `${this.userDeletedText}`;
    }
    const firstName = user?.firstname ?? user?.firstName;
    const lastName = user?.lastname ?? user?.lastName;

    if (firstName && lastName) {
      return `${firstCamelLastCapitalize ? this._capitalizePipe.transform(firstName) : firstName} ${firstCamelLastCapitalize ? lastName.toUpperCase() : lastName}`;
    }
    return '';
  }
}
